import React from 'react';
import classNames from 'classnames';
import { formatMessage } from '../../../../../utils/i18n';
import { EditableInput, Input } from '../../../inputs';

type Props = {
  name: string;
  editable: boolean;
  compact?: boolean;
  onNameChange: (name: string) => void;
};

const GroupInfoStep = (props: Props) => {
  const { name, editable, compact, onNameChange } = props;
  const InputTag = editable ? EditableInput : Input;
  const inputClasses = !editable ? 'is-editable' : '';
  const divClasses = !editable ? 'y-padding' : '';

  return (
    <div data-private data-dd-privacy="mask" className={classNames(divClasses, 'group-info-step')}>
      <InputTag
        className={inputClasses}
        compact={compact}
        placeholder={formatMessage('AddComparisonGroupModal.GroupInfoStep.Placeholder')}
        value={name}
        onValueChange={(value: string) => onNameChange(value)}
      />
      {!editable && (
        <div className="footer">
          <span>{formatMessage('AddComparisonGroupModal.GroupInfoStep.Instructions')}</span>
        </div>
      )}
    </div>
  );
};

export default GroupInfoStep;
